<div class="relative">
  <button type="button" class="bg-lGray900 rounded-3xl px-6 py-2.5 flex items-center gap-2 text-lWhite text-lg font-extralight light:font-medium" (click)="toggleOpen()">
    <l-icon>filter_alt</l-icon>
    <span>Filtrar</span>
  </button>

  @if (open) {
    <div open class="absolute top-12 right-0 mt-2 w-[460px] max-w-[calc(100vw-2rem)] bg-lGray900 rounded-2xl p-8 flex flex-col gap-6 z-50 transition-all duration-300" [class.min-h-[500px]]="isCategoryPanelOpen" lOutsideClick (outsideClick)="close()">

      <header class="flex items-center justify-between mb-2">
        <h3 class="text-lWhite text-base font-semibold">Filtro</h3>
        
        <button type="button" (click)="close()">
          <l-icon class="text-lWhite text-xl cursor-pointer">close</l-icon>
        </button>
      </header>

      @if (showLocationFilter) {
        <fieldset class="flex flex-col gap-4 border-0 p-0 m-0 min-w-0">
          <legend class="text-lWhite text-sm font-medium">Localização</legend>
          <div class="w-full rounded-full bg-[var(--lGray700)] p-2 flex items-center justify-between gap-1 overflow-hidden">
            <button
              type="button"
              class="h-10 flex-1 min-w-0 px-2 rounded-full text-sm font-light transition-colors flex items-center justify-center gap-1 border-0"
              [class.bg-lWhite]="draftSelectedLocation === null"
              [class.text-lBlack]="draftSelectedLocation === null"
              [class.shadow-soft-black]="draftSelectedLocation === null"
              [class.shadow-none]="draftSelectedLocation !== null"
              [class.text-lSecondary]="draftSelectedLocation !== null"
              [class.hover:text-lWhite]="draftSelectedLocation !== null"
              (click)="draftSelectedLocation = null"
            >
              <l-icon class="text-sm">auto_awesome</l-icon>
              <span>Todos</span>
            </button>
            @for (option of locationOptions; track option.value) {
              <button
                type="button"
                class="h-10 flex-1 min-w-0 px-2 rounded-full text-sm font-light transition-colors flex items-center justify-center gap-1 border-0"
                [class.bg-lWhite]="draftSelectedLocation === option.value"
                [class.text-lBlack]="draftSelectedLocation === option.value"
                [class.shadow-soft-black]="draftSelectedLocation === option.value"
                [class.shadow-none]="draftSelectedLocation !== option.value"
                [class.text-lSecondary]="draftSelectedLocation !== option.value"
                [class.hover:text-lWhite]="draftSelectedLocation !== option.value"
                (click)="draftSelectedLocation = option.value"
              >
                <l-icon class="text-sm">{{ option.icon }}</l-icon>
                <span>{{ option.label }}</span>
              </button>
            }
          </div>
        </fieldset>
      }

      @if (showTypeFilter) {
        <fieldset class="flex flex-col gap-4 border-0 p-0 m-0 min-w-0">
          <legend class="text-lWhite text-sm font-medium">Tipo</legend>
          <div class="w-full rounded-full bg-[var(--lGray700)] p-2 flex items-center justify-between gap-1 overflow-hidden">
            <button
              type="button"
              class="h-10 flex-1 min-w-0 px-2 rounded-full text-sm font-light transition-colors flex items-center justify-center gap-1 border-0"
              [class.bg-lWhite]="draftSelectedType === null"
              [class.text-lBlack]="draftSelectedType === null"
              [class.shadow-soft-black]="draftSelectedType === null"
              [class.shadow-none]="draftSelectedType !== null"
              [class.text-lSecondary]="draftSelectedType !== null"
              [class.hover:text-lWhite]="draftSelectedType !== null"
              (click)="draftSelectedType = null"
            >
              <l-icon class="text-sm">auto_awesome</l-icon>
              <span>Todos</span>
            </button>
            @for (option of typeOptions; track option.value) {
              <button
                type="button"
                class="h-10 flex-1 min-w-0 px-2 rounded-full text-sm font-light transition-colors flex items-center justify-center gap-1 border-0"
                [class.bg-lWhite]="draftSelectedType === option.value"
                [class.text-lBlack]="draftSelectedType === option.value"
                [class.shadow-soft-black]="draftSelectedType === option.value"
                [class.shadow-none]="draftSelectedType !== option.value"
                [class.text-lSecondary]="draftSelectedType !== option.value"
                [class.hover:text-lWhite]="draftSelectedType !== option.value"
                (click)="draftSelectedType = option.value"
              >
                <l-icon class="text-sm">{{ option.icon }}</l-icon>
                <span>{{ option.label }}</span>
              </button>
            }
          </div>
        </fieldset>
      }

      <fieldset class="flex flex-col gap-4 border-0 p-0 m-0 min-w-0">
        <legend class="text-lWhite text-sm font-medium">Categoria</legend>
        <l-multi-select
          [options]="categories"
          [(ngModel)]="draftSelectedCategories"
          [optionLabel]="'name'"
          [allOptionLabel]="'Todas'"
          [showClear]="true"
          placeholder="Selecione as categorias"
          (panelShow)="isCategoryPanelOpen = true"
          (panelHide)="isCategoryPanelOpen = false"
        ></l-multi-select>
      </fieldset>

      <footer class="flex gap-4 mt-6 relative z-10">
        <button lButton [bType]="buttonTypeEnum.OUTLINE" [bRadius]="buttonRadiusEnum.CIRCLE" class="flex-1 py-3 shadow-none" (click)="clearFilter()">Limpar filtro</button>

        <button lButton [bType]="buttonTypeEnum.PRIMARY" [bRadius]="buttonRadiusEnum.CIRCLE" class="flex-1 py-3 shadow-none" (click)="applyFilter()">Aplicar</button>
      </footer>
    </div>
  }
</div>
  